import type { Playbook } from '@squadlab/contracts';

/**
 * Annual-leave request playbook v1 (ADR 0052 — SOPs are content).
 *
 * The policy engine costs the request in working days and weighs it against
 * the balance (art. 109); the agent drafts the decision memo; the operator
 * decides at the gate; approval deducts the balance (the first real
 * record-update) and publishes `hr.leave.balance.updated.v1`.
 */
export const LEAVE_PLAYBOOK: Playbook = {
  key: 'leave-request',
  version: 1,
  function: 'time-leave',
  title: 'Annual leave request',
  steps: [
    {
      id: 'check-entitlement',
      kind: 'policy-check',
      title: 'Cost the request against the entitlement (art. 109)',
    },
    {
      id: 'draft-memo',
      kind: 'agent-draft',
      title: 'Draft the leave decision memo',
      instruction: 'Summarise the request, the balance arithmetic and any coverage considerations for the gate.',
    },
    {
      id: 'gate-decision',
      kind: 'human-gate',
      title: 'Operator decision on the leave request',
      instruction: 'Approve to deduct the balance, request a redo of the memo, or reject the request.',
    },
    {
      id: 'record-balance',
      kind: 'record-update',
      title: 'Deduct the approved days from the leave balance',
    },
  ],
};
